import React from 'react';

class Spinner extends React.Component {

  // ----------------------------------------
  // CSS Helpers
  // ----------------------------------------

  size() {
    if (this.props.size) {
      return (40 * this.props.size)
    } else {
      return 40
    }
  }

  margin() {
    if (this.props.margin !== null) {
      return this.props.margin
    } else {
      return 0
    }
  }

  padding() {
    if (this.props.padding !== null) {
      return this.props.padding
    } else {
      return 3
    }    
  }

  // ----------------------------------------
  // UI Helpers
  // ----------------------------------------

  animatedCircle() {
    return (
      <div className='sk-circle' style={{height: `${this.size()}px`, width: `${this.size()}px`, margin: '5px auto'}}>
        <div className='sk-child' />
      </div>
    )
  }

  counterIsPositive() {
    if (this.props.loading === true) {
      return (
        <div style={{margin: `${this.margin()}px`, padding: `${this.padding()}px`}} className='spinner-wrapper'>
          {
            this.props.overlayOnChildren
              ? (
                <>
                  <div className='spinner-circle'>{this.animatedCircle()}</div>
                  <div>
                    <div className={`${this.props.parentClassName} spinner-overlay`} />
                    <div key='spinner' ref='spinner' className={`${this.props.parentClassName} spinner-children`}>
                      {this.props.children}
                    </div>
                  </div>
                </>
              )
              : this.animatedCircle()
          }
        </div>
      )
    } else {
      let props    = { key: 'spinner', ref: 'spinner', className: this.props.parentClassName };
      let children = this.props.children;
      return React.createElement('div', props, children);
    }
  }

  // ----------------------------------------
  // DOM
  // ----------------------------------------

  render() {
    return (
      <div>
        {this.counterIsPositive()}
      </div>
    );
  }
}

export default Spinner;